import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/features/auth/AuthProvider'
import type { RolNivel } from '@/types/database'

interface Props {
  requiredNivel?: RolNivel
}

export default function ProtectedRoute({ requiredNivel }: Props) {
  const { session, rolNivel, loading } = useAuth()

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--me-bg)',
      }}>
        <div style={{
          width: 36,
          height: 36,
          border: '2px solid var(--me-line-2)',
          borderTopColor: 'var(--me-acid)',
          borderRadius: '50%',
          animation: 'me-spin 0.7s linear infinite',
        }} />
        <style>{`@keyframes me-spin { to { transform: rotate(360deg) } }`}</style>
      </div>
    )
  }

  if (!session) return <Navigate to="/login" replace />

  if (requiredNivel !== undefined && rolNivel !== null && rolNivel > requiredNivel) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
